import React from "react";
import { Tooltip } from "@mui/material";
import { X } from "lucide-react";
import ActivityFeed from "../FpPages/RMS/ActivityFeed";
import useDocumentMetadata from "./services/useDocumentMetadata";

interface DocumentActivityPanelProps {
  blobId: string | null;
  onClose: () => void;
}

/** The open document's history (#13433), in the slot the Details panel uses
 *  and with its header: the RMS activity feed in panel mode, scoped to this
 *  document, ending with how the document arrived. The arrival comes from
 *  the metadata Details already reads, so the two share one request. */
const DocumentActivityPanel: React.FC<DocumentActivityPanelProps> = ({
  blobId,
  onClose,
}) => {
  const { data: metadata } = useDocumentMetadata(blobId, true);

  return (
    <div
      className="h-full flex flex-col border-l border-gray-200 bg-white"
      data-document-activity
    >
      <div className="h-12 shrink-0 border-b border-gray-200 flex items-center justify-between px-3">
        <span
          role="heading"
          aria-level={3}
          className="text-sm font-semibold text-gray-700"
        >
          Activity
        </span>
        <Tooltip title="Close activity" arrow placement="bottom">
          <button
            onClick={onClose}
            className="p-1 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded cursor-pointer transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </Tooltip>
      </div>
      <div className="flex-1 min-h-0">
        {blobId && (
          <ActivityFeed
            variant="panel"
            documentId={blobId}
            arrival={metadata?.arrival ?? null}
            arrivalFolder={metadata?.filesystem_path ?? null}
          />
        )}
      </div>
    </div>
  );
};

export default DocumentActivityPanel;
